import React, { FC } from 'react';
import { useCss } from 'app/utils/css';
import { NavigationType, NavigationContext } from 'app/components/header/navigation/Navigation';
import { INavigationItemProps } from 'app/components/header/navigation/NavigationItem';
import NavLink from 'app/components/presentation/nav/NavLink';
import { INavigationLinkProps } from 'app/components/header/navigation/NavigationLink';
import NavDropdown from 'app/components/presentation/nav/NavDropdown';
import { INavigationSectionProps } from 'app/components/header/navigation/NavigationSection';

/**
 * @private Do not use directly except in tests and stories. Use {@link NavigationSection} instead
 */
export const HeaderSection: FC<INavigationSectionProps> = ({
  children,
  ...props
}) => {
  const css = useCss();
  return (
    <NavigationContext.Provider value={{ type: NavigationType.Dropdown }}>
      <NavDropdown showArrow={false} {...props}>
        <ul
          className={css('list', {
            listStyle: 'none',
            padding: 0,
            margin: 0,
          })}
        >
          {children}
        </ul>
      </NavDropdown>
    </NavigationContext.Provider>
  );
};

/**
 * @private Do not use directly except in tests and stories. Use {@link NavigationItem} instead
 */
export const HeaderItem: FC<INavigationItemProps> = ({ children }) => {
  const css = useCss();
  return (
    <div
      className={css('item', {
        height: '100%',
        padding: '0 0.5em',
        display: 'flex',
        alignItems: 'center',
      })}
    >
      {children}
    </div>
  );
};

/**
 * @private Do not use directly except in tests and stories. Use {@link NavigationLink} instead
 */
export const HeaderLink: FC<INavigationLinkProps> = ({ children, icon, selected, ...linkProps }) => (
  <NavLink selected={selected} {...linkProps}>
    {children}
  </NavLink>
);
